import ProductReviewHighLight, { ProductReviewHighLightProps } from './ProductReviewHighLight'
export default ProductReviewHighLight
export { ProductReviewHighLight }
export type { ProductReviewHighLightProps }
